
import React from 'react';
import { Link } from 'react-router-dom';
import Competences from '../../components/competences/competences';
import CompetenceTitle from '../../components/competenceTitle/competenceTitle';
import { NSCTotalService } from '../../services/NscTotalService';

import ReactPaginate from 'react-paginate';
import './competenceResult.css'
import ReactLoading from 'react-loading';

import {
  Row,
  Col,
  Container,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardSubtitle,
  Badge
} from "reactstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';


class CompetenceResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categorys: [],
      pageCount: 20,
      result: [],
      array: [1, 2, 3, 4, 5],
      isLoaded: true,
      offset: 0
    }
  }

  async componentDidUpdate(prevProps) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.props.competence !== prevProps.competence) {
      await this.setState({ isLoaded: true, offset: 0 });
      const result = await this.getNews();
      this.setState({ result: result, isLoaded: false });
    }
  }

  async getNews() {
    this.setState({ isLoaded: true });
    const competence = this.props.competence;
    return await NSCTotalService.getNews(competence, this.state.offset, this.props.columnist);
  }

  async componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const result = await this.getNews();
    this.setState({ result: result, isLoaded: false });
  }

  handlePageClick = async data => {
    let selected = data.selected;
    let offset = Math.ceil(selected * 12);
    this.setState({ offset: offset }, async () => {
      const result = await this.getNews();
      this.setState({ result: result, isLoaded: false });
    });
  };

  render() {
    return (
      <div>
        <Row className="bgCompetencesResult m-0">
          <Col>
            <Container fluid="true p-5">
              {this.state.isLoaded ? <div style={{ minHeight: '700px', display: 'flex', alignItems: 'center' }}>
                <ReactLoading type={'spin'} color={'#FFF'} height={'100px'} width={'100px'} className={"m-auto"} />
              </div> :
                <Row>
                  <Col md="12" className="mt-5 text-center">
                    <CompetenceTitle icon={this.props.icon} sigla={this.props.sigla} title={this.props.title}></CompetenceTitle>
                    <Badge color="warning" pill className="font14 mb-4 text-l">{this.state.result.news ? this.state.result.news.count + " resultados" : ''}</Badge>
                  </Col>
                  {this.state.result.news ?
                    this.state.result.news.entities.map(ele => {
                      return (
                        <Col xs="12" sm="12" md="4" lg="3" xl="2">
                          <Link to={`http://node.envolvetv.com.br${ele.url.alias}`} target='_blank' rel="noopener noreferrer">                            
                            <Card className="card-competencias">
                              <CardImg className="card-img-top card-thumbnail" src={ele.photo ? ele.photo.derivative.url : "https://semantic-ui.com/images/wireframe/image.png"} alt="Imagem Artigo" />
                              <CardBody>
                                <CardTitle>{ele.topper ? ele.topper.entity.entityLabel : "Notícia"}</CardTitle>
                                <CardSubtitle>{ele.title}</CardSubtitle>
                              </CardBody>
                            </Card>
                          </Link>
                        </Col>
                      )
                    }) : null
                  }
                </Row>
              }
              <Row>
                <Col className="d-flex justify-content-center">
                  <ReactPaginate                    
                    previousLabel={<FontAwesomeIcon icon={faAngleLeft} />}
                    nextLabel={<FontAwesomeIcon icon={faAngleRight} />}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    pageClassName={'pagination-item'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active-page'}
                  />
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Competences />
      </div>
    );
  }
}
export default CompetenceResult;